module.exports = __webpack_public_path__ + "img/txt_info4.613c5259.png";